import styled from "styled-components";

import backgroundLoading from "../../assets/login-background.jpg";

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #fff;

  width: 100%;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.8);

  align-items: center;
  background: url(${backgroundLoading}) no-repeat fixed rgba(0, 0, 0, 0.8);
  overflow: auto;
  background-position: center;
  background-size: cover;

  &::after {
    content: "";
    width: 100%;
    height: 100vh;
    left: 0;
    top: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.8);
  }

  > div {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    > img {
      margin: 20px;
      width: 600px;
      height: 200px;
    }
  }
`;
